const adminMeta = { hideNavbar: true, hideFooter: true };

export default [{
  path: '/admin',
  name: 'adminRoot',
  component: () => import(/* webpackChunkName: "admin" */ './admin.vue'),
  meta: adminMeta,
  children: [
    {
      path: '',
      name: 'adminHome',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './home/Home.vue'),
    },
    {
      path: 'users',
      name: 'adminUsers',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './users/Users.vue'),
    },
    {
      path: 'users/:id',
      name: 'adminUserDetail',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './users/UserDetail.vue'),
    },
    {
      path: 'companies',
      name: 'adminCompanies',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './companies/Companies.vue'),
    },
    {
      path: 'companies/:id',
      name: 'adminCompanyDetail',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './companies/CompanyDetail.vue'),
    },
    {
      path: 'servers',
      name: 'adminServers',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './servers/Servers.vue'),
    },
    {
      path: 'servers/:id',
      name: 'adminServerDetail',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './servers/ServerDetail.vue'),
    },
    {
      path: 'subscriptions',
      name: 'adminSubscriptions',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './subscriptions/Subscriptions.vue'),
    },
    {
      path: 'subscriptions/:id',
      name: 'adminSubscriptionDetail',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './subscriptions/SubscriptionDetail.vue'),
    },
    {
      path: 'operations',
      name: 'adminOperations',
      meta: adminMeta,
      component: () => import(/* webpackChunkName: "admin" */ './operations/Operations.vue'),
      redirect: { name: 'adminOperationDeploymentMigration' },
      children: [
        {
          path: 'deployment-migration',
          name: 'adminOperationDeploymentMigration',
          meta: adminMeta,
          component: () => import(/* webpackChunkName: "admin" */ './operations/DeploymentMigration.vue'),
        },
        {
          path: 'domain-transfer',
          name: 'adminOperationDomainTransfer',
          meta: adminMeta,
          component: () => import(/* webpackChunkName: "admin" */ './operations/DomainTransfer.vue'),
        },
        {
          path: 'set-server-url',
          name: 'adminOperationSetServerUrl',
          meta: adminMeta,
          component: () => import(/* webpackChunkName: "admin" */ './operations/SetServerUrl.vue'),
        },
        {
          path: 'retire-free-servers',
          name: 'adminOperationRetireFreeServers',
          meta: adminMeta,
          component: () => import(/* webpackChunkName: "admin" */ './operations/RetireFreeServers.vue'),
        },
        {
          path: 'unlock-users',
          name: 'adminOperationUnlockUsers',
          meta: adminMeta,
          component: () => import(/* webpackChunkName: "admin" */ './operations/UnlockUsers.vue'),
        },
        {
          path: 'send-deployment-creation-command',
          name: 'adminOperationSendDeploymentCreationCommand',
          meta: adminMeta,
          component: () => import(/* webpackChunkName: "admin" */ './operations/SendDeploymentCreationCommand.vue'),
        },
      ],
    },
  ],
}];
